module.exports = __webpack_public_path__ + "img/3x.41fcd64.jpg";